import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist';
Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});
export default new Vuex.Store({
  state: {
    edittableTabsValue:'/',
    edittableTabs:[
      {
        title:'首页',
        name:'/'
      }
    ],
    avator: ''
  },
  getters: {
  },
  mutations: {
    ADD_TABS:(state,tab)=>{
      if (state.edittableTabs.findIndex(e=>{        
        if (e.name == tab.path || e.title == tab.name) return true
        else return false
      }) == -1){
        state.edittableTabs.push({
          title:tab.name,
          name:tab.path
        })
      }
      state.edittableTabsValue = tab.path
    },
    SET_TAB:(state)=>{
      state.edittableTabsValue = '/'
      state.edittableTabs = [{
        title:'首页',
        name:'/'
      }]
    },
    
    
    SET_AVATOR:(state,avaor)=>{
      state.avator = avaor
    },
    SAVE_CUR_TAB:(state,tab)=>{
      state.edittableTabsValue = tab.path
    },
    SAVE_CUR_TABS:(state,tabs) => {
      state.edittableTabs = tabs
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [vuexLocal.plugin]
})
